<template>
    <div>
        <div class="flex-row" v-if="inputType == 'checkbox_input'">
            <div class="col-lg-6 col-sm-12">
                <input
                    :id      ="checkboxId"
                    type     ="checkbox"
                    :checked ="mostrar"
                    @change  ="manipulaMostrar"
                />

                <label :for="checkboxId"> {{label}} </label>

                <div class="description" v-if="description"> {{ description }} </div>
            </div>

            <div class="col-lg-5 col-sm-12 ml-8" v-if="mostrar">
                <div class="input-percent">
                    <input
                        type    ="number"
                        :step   ="fieldStep"
                        :max    ="valorMaximo"
                        :min    ="valorMinimo"
                        v-model.number="valorAtual"
                        class="form-control"
                        @input  ="$emit('input', valorAtual)"
                    />
                </div>
            </div>
        </div>

        <div class="flex-row" v-if="inputType == 'radio_select'">
            <div v-for="item in opcoes" :key="item.nome">
                <div class="col-lg-6 col-sm-12">

                    <input
                        :id      ="`${item.nome}_${checkboxId}`"
                        :name    ="name"
                        type     ="radio"
                        v-model  ="valorAtual"
                        :value   ="item.valor"
                        @change  ="$emit('input', item.valor)"
                    />

                    <label :for="`${item.nome}_${checkboxId}`"> {{item.nome}} </label>

                    <div class="description" v-if="description"> {{ description }} </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isEmpty } from 'lodash';

    export default {
        name: "CheckboxInput",

        props: {
            label      : String,
            description: String,
            valorMaximo: Number,
            valorMinimo: Number,
            fieldStep  : Number,
            checkboxId : String,
            value      : [
                Number,
                String
            ],
            inputType  : String,
            opcoes     : Array,
            name       : String,
        },

        data() {
            return {
                valorAtual: this.value,
                mostrar: false
            }
        },

        methods: {
            manipulaMostrar() {

                if (!!this.mostrar) {

                    this.valorAtual     = null;
                    return this.mostrar =  !this.mostrar;
                }

                return this.mostrar = !this.mostrar
            },
        },

        watch: {
            valorAtual(valorAtual) {
                this.$emit('input', valorAtual);
            },

            value:
            {
                immediate: true,
                handler(value) {
                    this.valorAtual = value;
                    this.mostrar    = value !== null;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.description{
    font-size: 12px;
    color    : #bbb;
}
</style>




// WEBPACK FOOTER //
// src/components/common/CheckboxInput.vue